export default __webpack_public_path__ + "23e0ab17cfc9e561163a8609fd30e05d.png";